// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__p14dZ","anim":"Alert_anim__pi95H","success":"Alert_success__KT9Y-","error":"Alert_error__5c0ma"};